import { FormControl, FormGroup } from '@angular/forms';

export class PhoneNumberVerificationCodeForm extends FormGroup {
  constructor(verificationCode: string = null) {
    super({
      verificationCode: new FormControl(verificationCode),
    });
  }

  get verificationCode(): FormControl {
    return this.get('verificationCode') as FormControl;
  }
}
